import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './stores/authStore';
import { useSocketStore } from './stores/socketStore';

// Pages
import HomePage from './pages/HomePage';
import CreateRoomPage from './pages/CreateRoomPage';
import RoomPage from './pages/RoomPage';
import GamePage from './pages/GamePage';
import ProfilePage from './pages/ProfilePage';
import LeaderboardPage from './pages/LeaderboardPage';
import PremiumPage from './pages/PremiumPage';
import GamesPage from './pages/GamesPage';
import EventPage from './pages/EventPage';

// Components
import Layout from './components/Layout';

function App() {
  const { checkAuth } = useAuthStore();
  const { connect } = useSocketStore();
  
  useEffect(() => {
    checkAuth();
    connect();
    return () => useSocketStore.getState().disconnect();
  }, [checkAuth, connect]);
  
  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/create" element={<CreateRoomPage />} />
          <Route path="/room/:code" element={<RoomPage />} />
          <Route path="/game/:code" element={<GamePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:id" element={<ProfilePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/premium" element={<PremiumPage />} />
          <Route path="/event" element={<EventPage />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;
